import _ from 'lodash';
import $ from 'jquery';
import widgetFactory from './widgetFactory';

const widgetName = 'autocomplete';

// widget definition
const widget = widgetFactory(widgetName, {
  options: {
    minimumItemCount: null,
    minimumItemError: '',
    disabled: false,
    noFieldUpdate: false,
    multiple: false,
    source: null,
    searchArgName: 'q',
    onRemoveItem: $.noop,
    onChange: $.noop,
    resultFilterIds: [],
    dataMapping: {
      image: 'image',
      label: 'label',
      id: 'id',
    },
  },

  _create: function () {
    this._super(widgetName);

    this.elements.$field = this.getWidgetElement('field');
    this.elements.$hiddenSelect = this.getWidgetElement('select');

    this._initHiddenSelectData();

    this.elements.$multiSelectedList = this.getWidgetElement('multiSelectedList');

    if (this.options.multiple) {
      this.elements.$hiddenSelect.attr('multiple', true);
    } else {
      this._updateVisualFieldText(this.elements.$hiddenSelect.find('option:selected').text());
    }

    if (this.options.disabled) {
      this.disable();
    }

    this._createAutocompleteUi();
    this.updateMultiSelectedList();

    this._addEvents();
  },

  _addEvents: function () {
    const self = this;

    if (self.options.multiple) {
      self.elements.$multiSelectedList.on('click', '.js-autocomplete-removeItem', function () {
        if (this.classList.contains('js-item-disabled')) {
          return;
        }
        const data = $(this).closest('.js-autocomplete-item').data();
        self.unselect(data);
        self.updateMultiSelectedList();
      });
    } else {
      this.elements.$field.on('blur', function () {
        const $this = $(this);
        let value;

        if (self.options.noFieldUpdate) {
          self._updateVisualFieldText('');
        } else {
          if ($this.val() === '') {
            self.unselectAll();
          } else {
            value = self.getValues().pop();
            if (value) {
              self._updateVisualFieldText(value.label);
            }
          }
        }
      });
      this.elements.$field.on('input', function () {
        if (self.options.noFieldUpdate) {
          return;
        }

        let value;

        if ($(this).val() === '') {
          self.unselectAll();
        } else {
          value = self.getValues().pop();
          if (typeof value !== 'undefined') {
            self._getOptionById(value.id, true).remove();
          }
        }
      });
    }
  },

  _initHiddenSelectData: function () {
    this._getAllOptions().each(function (n, option) {
      var $option = $(option);
      $option.data({
        id: $option.val(),
        label: $option.text(),
        readOnly: !!$option.attr('readonly'),
      });
    });
  },

  _renderResultItem: function () {
    var defaultTemplateString =
        '<li>' +
        '  <a>' +
        '      <% if (typeof image !== "undefined" ) { %>' +
        '          <img src="<%= image %>">' +
        '      <% } %>' +
        '      <span><%- label %></span>' +
        '  </a>' +
        '</li>',
      templateString,
      template;

    templateString = this.element.find('script[type="text/template"]').text();

    if (!templateString) {
      templateString = defaultTemplateString;
    }

    template = _.template(templateString);

    return function (ul, item) {
      return $(template(item)).appendTo(ul);
    };
  },

  _setLoading: function (state) {
    this.element.toggleClass('isLoading', state);
  },

  _dataMap: function (data) {
    const mapping = this.options.dataMapping;
    const returnData = [];

    data.forEach((item) => {
      var newItem = {};

      Object.keys(mapping).forEach(function (mapKey) {
        const value = _.isString(item) ? item : item[mapping[mapKey]];
        newItem[mapKey] = value;
      });

      const id = newItem[mapping['id']];
      if (this.isSelected(id) || _.includes(this.options.resultFilterIds, id)) {
        return;
      }

      returnData.push(newItem);
    });

    return returnData;
  },

  _createAutocompleteUi: function () {
    var self = this,
      autocompleteOptions;

    autocompleteOptions = {
      appendTo: this.element,
      minLength: 2,
      delay: 700,
      select: function (event, data) {
        self.select(data.item);

        if (self.options.multiple || self.options.noFieldUpdate) {
          event.preventDefault();
        }
      },
    };

    autocompleteOptions.source = this.getSourceFunction(this.options.source).bind(this);

    $.ui.autocomplete(autocompleteOptions, this.elements.$field);

    this.elements.$field.data('ui-autocomplete')._renderItem = this._renderResultItem();
  },

  getSourceFunction: function (source) {
    if ($.isArray(source)) {
      return this._arraySourceHandler;
    } else if (_.isFunction(source)) {
      return this._functionSourceHandler;
    } else {
      return this._ajaxSourceHandler;
    }
  },

  _functionSourceHandler: function (request, response) {
    var func = this.options.source;

    this._setLoading(true);

    func(
      request,
      function (data) {
        this._setLoading(false);
        response(this._dataMap(data));
      }.bind(this)
    );
  },

  _arraySourceHandler: function (request, response) {
    var data = this._dataMap(this.options.source),
      matcher = new RegExp($.ui.autocomplete.escapeRegex(request.term), 'i');

    response(
      $.grep(data, function (item) {
        return matcher.test(item.id) || matcher.test(item.label);
      })
    );
  },

  _ajaxSourceHandler: function (request, response) {
    var self = this,
      opts = {};

    this._setLoading(true);
    opts[this.options.searchArgName] = request.term;

    $.getJSON(this.options.source, opts)
      .done(function (data) {
        response(self._dataMap(data));
      })
      .always(function () {
        self._setLoading(false);
      });
  },

  _updateHiddenSelect: function (data) {
    var $option = $('<option>')
      .data(data)
      .attr({
        selected: true,
      })
      .val(data.id)
      .text(data.label);

    if (!this.options.multiple) {
      this.elements.$hiddenSelect.empty();
    }

    this.elements.$hiddenSelect.append($option);
  },

  _updateVisualFieldText: function (value) {
    this.elements.$field.val(value);
  },

  updateMultiSelectedList: function () {
    var self = this,
      $options = this.elements.$hiddenSelect.find('option');

    if ($options.length > 0 && this.options.multiple) {
      this.elements.$multiSelectedList.empty();

      $options.each(function (n, option) {
        var $opt = $(option);
        if ($opt.attr('selected')) {
          self._renderSelectedItem(self.elements.$multiSelectedList, $opt.data());
        }
      });
      this.elements.$multiSelectedList.show();
    } else {
      this.elements.$multiSelectedList.hide();
    }
  },

  _renderSelectedItem: function ($parent, item) {
    var $container = $('<li>'),
      $label = $('<span>').appendTo($container);

    const $labelContent = $('<span class="label__text" />').text(item.label);

    $label
      .addClass('autocomplete__item  label  grey  js-autocomplete-item')
      .data(item)
      .append($labelContent);

    if (!item.readOnly && !this.options.disabled) {
      let minimumItemCountClass = '';
      let minimumItemError = '';

      if (this.options.minimumItemCount >= this.elements.$hiddenSelect.find('option').length) {
        minimumItemCountClass = 'js-item-disabled js-tooltip label__closeButton--disabled';
        minimumItemError = this.options.minimumItemError;
      }
      $label.append(
        `<a class="label__closeButton js-autocomplete-removeItem ${minimumItemCountClass}" title="${minimumItemError}">×</a>`
      );
    }

    return $parent.append($container);
  },

  _onChange: function () {
    this._trigger('onChange', null, { values: this.getValues() });
  },

  disable: function () {
    this.options.disabled = true;
    this.elements.$field.prop('disabled', true);
  },

  enable: function () {
    this.options.disabled = false;
    this.elements.$field.prop('disabled', false);
  },

  setSelected: function (itemList) {
    let mappedData;
    const isAlreadyDataMapped = itemList[0] && itemList[0].label;

    if (isAlreadyDataMapped) {
      mappedData = itemList;
    } else {
      mappedData = this._dataMap(itemList);
    }

    this.elements.$hiddenSelect.empty();

    mappedData.forEach(
      function (item) {
        this._updateHiddenSelect(item);
      }.bind(this)
    );

    if (mappedData.length === 0) {
      return;
    }

    if (this.options.multiple) {
      this.updateMultiSelectedList();
    } else {
      this._updateVisualFieldText(mappedData[0].label);
    }
  },

  select: function (data) {
    if (!this.isSelected(data.id)) {
      this._updateHiddenSelect(data);

      if (this.options.multiple) {
        this.updateMultiSelectedList();
      } else {
        this._updateVisualFieldText(data.label);
      }

      this._trigger('onAddItem', null, { newValue: data });

      this._onChange(data);
    }

    if (this.options.multiple) {
      this._updateVisualFieldText('');
    }

    if (this.options.noFieldUpdate) {
      this.unselectAll();
    }
  },

  unselect: function (data) {
    if (this._trigger('onRemoveItem', null, { id: data.id })) {
      this._getOptionById(data.id, true).remove();

      this._onChange();
    }
  },

  unselectAll: function () {
    this._updateVisualFieldText('');

    if (this.options.multiple) {
      this.elements.$multiSelectedList.empty().hide();
    }

    this._getAllOptions(true).remove();

    this._onChange();
  },

  isSelected: function (id) {
    return !!this._getOptionById(id).length;
  },

  getValues: function () {
    var values = [];

    this._getAllOptions(true).each(function (n, option) {
      values.push($(option).data());
    });

    return values;
  },

  _getOptionById: function (id, selected) {
    var selector = 'option[value="' + id + '"]';
    if (selected) {
      selector += ':selected';
    }

    return this.elements.$hiddenSelect.find(selector);
  },

  _getAllOptions: function (selected) {
    var selector = 'option';
    if (selected) {
      selector += ':selected';
    }

    return this.elements.$hiddenSelect.find(selector);
  },
});

export default widget;
